import React from 'react';
import { getClass } from '../_lib/helper';
import './Quote.scss';
function Quote(_a) {
    var id = _a.id, className = _a.className, children = _a.children;
    return (React.createElement("div", { "data-testid": "elmo-quote-" + (id || 'default'), className: getClass('elmo-quote', className) }, children));
}
export default Quote;
